// Does a check of the user's current order and the order that is saved
// in the database. It is used to determine if the user needs to refresh the
// webpage before they make any changes.
import firebase from "./../components/Firebase.js";
import LoadCommunityOrders from "../pages/MyAccountPage/Functions/LoadingOrderHistory/LoadCommunityOrders.js";

// Deep compare that ignores object key order, ignoring any 'selectedDate'
function deepEqual(a, b) {
  // Handle NaN specially: NaN !== NaN, but we want them equal
  if (
    typeof a === "number" &&
    typeof b === "number" &&
    Number.isNaN(a) &&
    Number.isNaN(b)
  ) {
    return true;
  }
  // Same reference or primitive
  if (a === b) return true;

  // Handle null
  if (a === null || b === null) return a === b;

  // Arrays
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;

    // Special case: sort foodList arrays by 'item'
    if (a[0]?.item !== undefined && b[0]?.item !== undefined) {
      a = [...a].sort((x, y) => x.item.localeCompare(y.item));
      b = [...b].sort((x, y) => x.item.localeCompare(y.item));
    }

    for (let i = 0; i < a.length; i++) {
      if (!deepEqual(a[i], b[i])) return false;
    }
    return true;
  }

  // Objects
  if (typeof a === "object" && typeof b === "object") {
    // Some objects have different selectedDates or there is
    // an extra field added that we want to ignore.
    const ignore = ["selectedDate", "distributionDate"];

    // Filter out 'selectedDate' from keys
    const aKeys = Object.keys(a)
      .filter((k) => !ignore.includes(k))
      .sort();
    const bKeys = Object.keys(b)
      .filter((k) => !ignore.includes(k))
      .sort();

    if (aKeys.length !== bKeys.length) {
      return false;
    }

    for (let i = 0; i < aKeys.length; i++) {
      if (aKeys[i] !== bKeys[i]) {
        return false;
      }
      if (!deepEqual(a[aKeys[i]], b[bKeys[i]])) {
        return false;
      }
    }

    return true;
  }

  // Fallback for different types
  return false;
}

export default async function CheckOrderSync(order) {
  const currentUser = firebase.auth().currentUser;
  const database = firebase.firestore();
  const noop = () => {};

  // This loads the community orders.  This is needed as we may need
  // to load orders that span multiple documents.
  const liveOrder = await LoadCommunityOrders(
    database,
    currentUser,
    1,
    noop,
    noop,
    noop,
    {},
    noop,
    false,
    null,
    null,
    order.orderDate,
  );

  // Compare the local and the database orders.
  // Since LoadCommunityOrders returns multiple orders we just
  // want to look at the first one.
  const isSame = deepEqual(liveOrder[0], order);

  return {
    refreshNeeded: !isSame,
  };
}
